import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13.196 7.984a1.21 1.21 0 0 0-1.204-1.19 1.21 1.21 0 0 0-1.205 1.19c0 .658.547 1.204 1.204 1.204.659 0 1.204-.546 1.204-1.204m-.209 2.142H11.01V17h1.975z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
      clipRule: "evenodd"
    }
  )
);
var SvgInformationOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var InformationOutlined_default = SvgInformationOutlined;

export { InformationOutlined_default as default };
